import Axios from "axios";

export const fetchAnnouncementsStart = (requestBody) => ({
  type: "FETCH_ANNOUNCEMENTS_START",
  payload: (requestBody==='NSW TrainLink'||requestBody==='NSWTrainLink')?'TrainLink':requestBody
});

export const fetchAnnouncementsSuccess = (announcements) => ({
  type: "FETCH_ANNOUNCEMENTS_SUCCESS",
  payload: announcements
});

export const fetchAnnouncementsFailure = (error) => ({
  type: "FETCH_ANNOUNCEMENTS_FAILURE",
  payload: error
});
export const saveAnnouncementsStart = (announcements) => ({
  type: "SAVE_ANNOUNCEMENTS_START",
  payload:announcements
});

export const saveAnnouncementsSuccess = () => ({
  type: "SAVE_ANNOUNCEMENTS_SUCCESS",
});

export const saveAnnouncementsFailure = (error) => ({
  type: "SAVE_ANNOUNCEMENTS_FAILURE",
  payload: error
});

